<template>
  <div class="contact-form" :class="{ open: $store.state.contact }">
    <div class="contact-form__header">
      <div class="contact-form__back" @click="$store.commit('SET_CONTACT', false)">
        <img src="/static/vector/arrow.svg" alt="Back Home">
        <span></span>
      </div>
      <div class="contact-form__label">Back Home</div>
    </div>

    <form action="" ref="form">
      <div class="form__row-label">
        <span v-if="$store.state.lang === 'en'">NAME</span>
        <span v-if="$store.state.lang === 'es'">NOMBRE</span>
      </div>
      <div class="form__row-input" ref="name">
        <input type="text" name="name" id="name" autocomplete="off">
      </div>

      <div class="form__row-label">
        <span>EMAIL</span>
      </div>
      <div class="form__row-input" ref="email">
        <input type="email" name="email" id="email" autocomplete="off">
      </div>

      <div class="form__row-label">
        <span v-if="$store.state.lang === 'en'">PHONE</span>
        <span v-if="$store.state.lang === 'es'">TELÉFONO</span>
      </div>
      <div class="form__row-input">
        <input type="tel" name="tel" id="tel" autocomplete="off">
      </div>

      <div class="form__row-label">
        <span v-if="$store.state.lang === 'en'">MESSAGE</span>
        <span v-if="$store.state.lang === 'es'">MENSAJE</span>
      </div>
      <div class="form__row-input">
        <textarea rows="1"></textarea>
      </div>

      <div class="form__row-placeholder">
        <div class="form__row-label">MESSAGE</div>
      </div>
      <div class="form__row-container">
        <div class="form__row-privacy" ref="privacy">
          <input type="checkbox" id="privacy" name="privacy" />
          <label v-if="$store.state.lang === 'en'" for="privacy">Accept <a target="_blank" href="https://www.iubenda.com/privacy-policy/13526818/">Privacy</a></label>
          <label v-if="$store.state.lang === 'es'" for="privacy"><a target="_blank" href="https://www.iubenda.com/privacy-policy/57022479">Política de privacidad</a></label>
        </div>
        <div class="form__row-send" @click="sendForm">
          <span v-if="$store.state.lang === 'en'">SEND</span>
          <span v-if="$store.state.lang === 'es'">CONTACTA</span>
        </div>
      </div>
    </form>

    <div class="form__overlay form__overlay--sending" v-if="state === 'sending'">
      <span>SENDING</span>
    </div>
    <div class="form__overlay form__overlay--sended" v-if="state === 'sended'">
      <span>SENDED</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ContactForm',

  data() {
    return {
      state: '',
    };
  },

  methods: {
    sendForm() {
      const errors = [...this.$el.querySelectorAll('.error')];
      errors.forEach(e => e.classList.remove('error'));
      const formData = new FormData(this.$refs.form);
      let valid = true;
      if (formData.get('name').length < 1) {
        this.$refs.name.classList.add('error');
        valid = false;
      }
      if (formData.get('privacy') !== 'on') {
        this.$refs.privacy.classList.add('error');
        valid = false;
      }
      if (formData.get('email').indexOf('@') < 2 || formData.get('email').indexOf('.') < 2) {
        this.$refs.email.classList.add('error');
        valid = false;
      }
      if (valid) {
        this.state = 'sending';
        const data = {};
        formData.forEach((value, key) => { data[key] = value; });

        axios('https://us-central1-diesel-wynwood.cloudfunctions.net/api/sendMail', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          data: JSON.stringify(data),
        }).then((response) => {
          if (response.status) {
            this.state = 'sended';
            setTimeout(() => { this.state = ''; }, 4000);
          } else {
            this.state = 'error';
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-form {
  @extend %full-fixed;
  background-color: $color-dark;
  color: $color-white;
  padding: calc((100vh / 18) * 1) calc((100vw / 32) * 1);
  padding-top: calc((100vh / 18) * 3);

  transform: translateY(100%);
  transition: transform .6s $inOutCubic;

  z-index: 3;

  @include mq($until: ipadP) {
    padding: calc((100vh / 18) * 1) calc((100vw / 32) * 2);
    padding-top: calc((100vh / 18) * 3);
  }

  &__header {
    position: absolute;
    top: calc((100vh / 18) * 1);
    padding: 0px calc((100vw / 32) * 1);
    left: 0px;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__back {
    display: flex;
    cursor: pointer;

    img {
      transform: scaleX(-1);
      margin-right: 30px;
    }
  }

  form {
    position: relative;
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-rows: repeat(5, 1fr);

    @include mq($until: ipadP) {
      display: block;
    }
  }

  &.open {
    transform: translateY(0%);
  }

  .form__row {
    &-label {
      padding-right: 40px;
    }

    &-label span,
    &-input input,
    &-input textarea {
      width: 100%;
      font-size: rem(120px);
      font-size: calc(120px * var(--rw));
      line-height: rem(120px);
      line-height: calc(120px * var(--rw));
      padding: 0px;
      border-radius: 0px;

      @include mq($until: ipadP) {
        font-size: rem(50px);
        font-size: calc(50px * var(--rw));
        line-height: rem(50px);
        line-height: calc(50px * var(--rw));
        margin-bottom: 10px;
      }
    }

    &-input {
      @include mq($until: ipadP) {
        margin-bottom: 20px;
      }
    }

    &-input textarea {
      padding-bottom: calc(10px * var(--rw));
    }

    &-input input,
    &-input textarea {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid $color-white;

      &:focus {
        outline: none;
      }
    }

    &-container {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-placeholder {
      opacity: 0;
    }

    &-send {
      position: relative;
      font-size: rem(70px);
      font-size: calc(70px * var(--rw));
      line-height: rem(70px);
      line-height: calc(70px * var(--rw));

      &::after {
        content: ' ';
        position: absolute;
        left: 0px;
        bottom: -4px;
        width: 100%;
        height: 1px;
        background-color: $color-white;
      }
    }

    &-privacy {
      position: relative;
      left: 10px;

      label {
        position: relative;
        left: 40px;
        cursor: pointer;

        a {
          text-decoration: underline;
        }

        @include mq($until: ipadP) {
          left: 20px;
          bottom: 5px;
        }
      }

      input[type="checkbox"] {
        position: relative;

        &::after {
          content: ' ';
          position: absolute;
          width: 20px;
          height: 20px;
          transform: translateX(-2.5px) translateY(-2.5px);
          border-radius: 100%;
          background-color: $color-white;
          display: none;

          @include mq($until: ipadP) {
            transform: translateX(-50%) translateY(-50%);
          }
        }

        &::before {
          content: ' ';
          position: absolute;
          top: -20px;
          left: -20px;
          width: calc(70px * var(--rw));
          height: calc(70px * var(--rw));
          border: 1px solid white;
          background-color: $color-dark;
        }

        &:checked::before {
          background-color: $color-white;
        }
      }
    }
  }

  .form__overlay {
    @extend %full;
    background-color: rgba($color: $color-dark, $alpha: 0.8);

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: rem(200px);
    font-size: calc(200px * var(--rw));
    line-height: rem(200px);
    line-height: calc(200px * var(--rw));
    color: $color-white;
  }

  .error input {
    border-color: rgb(196, 25, 25);

    &::after,
    &::before {
      border-color: rgb(196, 25, 25) !important;
    }
  }
}
</style>
